import { render, staticRenderFns } from "./DashboardMetrics.vue?vue&type=template&id=6d71abf0&scoped=true"
import script from "./DashboardMetrics.vue?vue&type=script&lang=ts"
export * from "./DashboardMetrics.vue?vue&type=script&lang=ts"
import style0 from "./DashboardMetrics.vue?vue&type=style&index=0&id=6d71abf0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d71abf0",
  null
  
)

export default component.exports